'use client'

import { ActionList } from 'fukku/ActionList/ActionList'
import { useLabels } from 'labels/hooks/useLabels/useLabels'
import { HelpClientLink } from 'links/help/client/index'
import type { ReactElement } from 'react'
import { cx } from 'utils/cx'

import styles from '../HelpModule.module.scss'
import text from 'fukku/styles/texts.module.scss'

type ClientHelpModuleProps = {
	readonly children: ReactElement[]
	readonly className?: string
	readonly onClick?: () => void
	readonly titleKey: string
	readonly moreKey: string
	readonly 'data-testid'?: string
	readonly titleTextStyle?: string
}

export const ClientHelpModule = ({
	children,
	className,
	onClick = () => {},
	titleKey,
	moreKey,
	'data-testid': dataTestId,
	titleTextStyle,
}: ClientHelpModuleProps) => {
	const { t } = useLabels()

	return (
		<div
			className={`${styles.helpContainer} ${className}`}
			data-testid={dataTestId}
		>
			<div className={styles.helpHeader}>
				<p className={cx(styles.helpTitle, titleTextStyle ?? text.uppercaseL)}>
					{t(titleKey)}
				</p>
				<HelpClientLink className={styles.moreLink} onClick={onClick}>
					{t(moreKey)}
				</HelpClientLink>
			</div>
			<ActionList>{children}</ActionList>
		</div>
	)
}
